import React, { useRef, useState } from "react";
import { Button, Col, Input, Row, Table, Typography } from "antd";

import { CSVLink } from "react-csv";
import { headers } from "./headers";
import { useReactToPrint } from "react-to-print";

const { Search } = Input;
const { Title } = Typography;

const ListRequete = (props) => {
  const [filterData, setFilterData] = useState(null);
  const { listData, tableOption } = props;

  const componentRef = useRef();

  const search = (value) => {
    const { listData } = props;

    const filterData = listData.filter((o) => {
      const p = o.requete_locataire?.locataire_personne;
      return Object.keys(p).some((k) => String(p[k]).toLowerCase().includes(value.toLowerCase()));
    });

    setFilterData(value ? filterData : listData);
  };

  const onClickAfficher = (requete) => {
    const pane = { key: "26", title: "requete", content: "" };
    props.addPanesRequete(pane, "26", requete);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div style={{ padding: 20 }}>
        <Row>
          <Title level={2}>Liste des requêtes archivées</Title>
        </Row>
        <Row>
          <Col span={12}>
            <Search
              placeholder="Recherche..."
              allowClear
              onSearch={search}
              style={{ width: 300 }}
            />
          </Col>
          <Col span={12}>
            <div style={{ float: "right" }}>
              <Button onClick={handlePrint} className="btn-primary">
                PDF
              </Button>
              {listData && (
                <Button style={{ marginLeft: 10 }}>
                  <CSVLink
                    filename={"export.csv"}
                    data={listData}
                    headers={headers()}
                    separator={";"}
                  >
                    Export CSV
                  </CSVLink>
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div ref={componentRef}>
        {listData && (
          <Table
            className="list-data"
            dataSource={filterData ? filterData : listData}
            columns={tableOption(onClickAfficher)}
            pagination={false}
            rowKey="requete_id"
          />
        )}
      </div>
    </>
  );
};

export default ListRequete;
